import React from "react";
import { useHasPermission } from "../../hooks/useHasPermission";

interface PermissionGuardProps {
  /** One or more permissions required to render children. All must be satisfied. */
  permissions: string[];
  children: React.ReactNode;
  /** Optional fallback rendered when the user lacks the required permissions. */
  fallback?: React.ReactNode;
}

/**
 * Renders children only when the authenticated user has ALL required permissions.
 * Renders `fallback` (or nothing) otherwise.
 */
export function PermissionGuard({
  permissions,
  children,
  fallback = null,
}: PermissionGuardProps) {
  const hasPermission = useHasPermission(...permissions);

  if (!hasPermission) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
